import { useState } from "react";

import { SubscribeModal } from "./SubscribeModal";
import { ThemeToggle } from "./ThemeToggle";

/**
 * Common top bar for status pages — brand eyebrow on the left,
 * Subscribe CTA + theme toggle on the right. The Subscribe modal is
 * owned by the bar so any page just drops `<StatusTopBar />` to opt in.
 */
export function StatusTopBar(): JSX.Element {
  const [open, setOpen] = useState(false);
  return (
    <>
      <header className="mb-6 flex flex-wrap items-center justify-between gap-3 no-print">
        <p className="eyebrow">Collect & Track · Status</p>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setOpen(true)}
            className="rounded-md bg-dr-blue px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white shadow-sm hover:opacity-90"
          >
            Subscribe to updates
          </button>
          <ThemeToggle />
        </div>
      </header>
      {open && <SubscribeModal onClose={() => setOpen(false)} />}
    </>
  );
}
